import { styled } from '@mui/material/styles';
import { Flex } from '../../Flex';
import { Pagination, useIsPaginationVisible } from './Pagination';

const Root = styled(Flex, { name: 'Footer', slot: 'Root' })(({ theme }) => ({
  position: 'sticky',
  left: 0,
  bottom: 0,
  zIndex: 10,
  marginTop: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
}));

const useIsFooterVisible = () => {
  const isPaginationVisible = useIsPaginationVisible();
  return isPaginationVisible;
};

export const Footer = () => {
  const isVisible = useIsFooterVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <Root gap={1} className="Table-footer">
      <div style={{ flex: 1 }} />
      <Pagination />
    </Root>
  );
};
